import { render, staticRenderFns } from "./PayerBillsDetails.vue?vue&type=template&id=2505acff&scoped=true"
import script from "./PayerBillsDetails.vue?vue&type=script&lang=js"
export * from "./PayerBillsDetails.vue?vue&type=script&lang=js"
import style0 from "./PayerBillsDetails.vue?vue&type=style&index=0&id=2505acff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505acff",
  null
  
)

export default component.exports